import { Routes, Route } from "react-router-dom";

// Main Pages
import Home from "../pages/Home";
import Work from "../pages/Work";
import Products from "../pages/Products";
import Services from "../pages/Services";
import Careers from "../pages/careers";
import Contact from "../pages/Contact";
import Apply from "../pages/Apply";

// Service Pages
import WebDevelopment from "../pages/WebDevelopment";
import MobileApp from "../pages/MobileApp";
import UI from "../pages/UI";
import Upcoming from "../pages/upcoming";

// Product Pages
import PaymentGateway from "../pages/PaymentGateway";
import BankingApis from "../pages/BankingApis";
import VerificationSuite from "../pages/VerificationSuite";
import AutomationTools from "../pages/AutomationTools";

// Solutions
import Solutions from "../pages/Solutions";
import EcommerceSolutions from "../pages/EcommerceSolutions";
import LogisticsSolutions from "../pages/LogisticsSolutions";
import HealthcareSolutions from "../pages/HealthcareSolutions";
import MarketplaceSolutions from "../pages/MarketplaceSolutions";
 import PrivacyPolicy from "../pages/PrivacyPolicy";
    import TermsOfService from "../pages/TermsOfService";
    import RefundCancellation from "../pages/RefundCancellation";
    import GrievanceRedressal from "../pages/GrievanceRedressal";


function AppRoutes() {
  return (
    <Routes>
      {/* Main Pages */}
      <Route path="/" element={<Home />} />
      <Route path="/work" element={<Work />} />
      <Route path="/products" element={<Products />} />
      <Route path="/services" element={<Services />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/apply" element={<Apply />} />

      {/* Service Pages */}
      <Route path="/webdevelopment" element={<WebDevelopment />} />
      <Route path="/mobileapp" element={<MobileApp />} />
      <Route path="/ui" element={<UI />} />
      <Route path="/upcoming" element={<Upcoming />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
         <Route path="/terms" element={<TermsOfService />} />
         <Route path="/refund-cancellation" element={<RefundCancellation />} />
<Route path="/grievance-redressal" element={<GrievanceRedressal />} />

      {/* Product Pages */}
      <Route
        path="/products/payment-gateway"
        element={<PaymentGateway />}
      />
      <Route
        path="/products/banking-apis"
        element={<BankingApis />}
      />
      <Route
        path="/products/verification-suite"
        element={<VerificationSuite />}
      />
      <Route
        path="/products/automation-tools"
        element={<AutomationTools />}
      />

      {/* Solutions */}
      <Route path="/solutions" element={<Solutions />} />
      <Route
        path="/solutions/ecommerce"
        element={<EcommerceSolutions />}
      />
      <Route
        path="/solutions/logistics"
        element={<LogisticsSolutions />}
      />
      <Route
        path="/solutions/healthcare"
        element={<HealthcareSolutions />}
      />
      <Route
        path="/solutions/marketplace"
        element={<MarketplaceSolutions />}
      />
      
    </Routes>
    
  );
}

export default AppRoutes;